import { render, staticRenderFns } from "./NewBadge.vue?vue&type=template&id=d8d67bc8&scoped=true"
import script from "./NewBadge.vue?vue&type=script&lang=js"
export * from "./NewBadge.vue?vue&type=script&lang=js"
import style0 from "./NewBadge.vue?vue&type=style&index=0&id=d8d67bc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8d67bc8",
  null
  
)

export default component.exports